import { render } from "./Challenge.vue?vue&type=template&id=37f09c68&scoped=true"
import script from "./Challenge.vue?vue&type=script&lang=js"
export * from "./Challenge.vue?vue&type=script&lang=js"

import "./Challenge.vue?vue&type=style&index=0&id=37f09c68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37f09c68"

export default script